import {Component, computed, inject} from '@angular/core';
import {RegistryService} from '../../services/RegistryService';
import {LayoutService} from '../../services/LayoutService';
import {PanelMenu} from 'primeng/panelmenu';
import {RouterLink} from '@angular/router';
import {translate, TranslocoService} from '@jsverse/transloco';
import {AuthService} from '../../services/AuthService';
import {FormsModule} from '@angular/forms';
import {NgOptimizedImage} from '@angular/common';
import {BranchSwitcher} from './branch-switcher';

const ServiceIconMap: { [key: string]: string } = {
  "lite_schedule": "pi pi-calendar"
}

@Component({
  selector: 'app-menu',
  imports: [
    PanelMenu,
    RouterLink,
    FormsModule,
    NgOptimizedImage,
    BranchSwitcher
  ],
  template: `
    <div class="h-full flex flex-col gap-1">
      <div class="justify-center mb-4 sm:flex hidden">
        <a routerLink="/dashboard" class="flex">
          <img ngSrc="/logo.svg" [height]="80" [width]="80"
               style="max-height: 80px;max-width:80px;margin:auto 0;" alt="logo" class="dark:hidden">
          <img ngSrc="/logo.dark.svg" [height]="80" [width]="80"
               style="max-height: 80px;max-width:80px;margin:auto 0;" alt="logo" class="hidden dark:block">
        </a>
      </div>
      <app-branch-switcher class="block sm:hidden"/>
      <p-panel-menu [model]="items()" [multiple]="true"/>
    </div>
  `,
})
export class MenuComponent {
  public auth = inject(AuthService)
  public t = inject(TranslocoService)
  public registry = inject(RegistryService);
  public layoutService = inject(LayoutService);
  public items = computed(() => {
    const menu = [
      {label: translate('Dashboard'), icon: 'pi pi-home', routerLink: '/dashboard', command: () => this.layoutService.mobileMenuOpen.set(false)},
      {
        label: translate('HR'),
        expanded: true,
        items: [
          {label: translate('Employees'), icon: 'pi pi-user', routerLink: '/hr/employees', command: () => this.layoutService.mobileMenuOpen.set(false)},
          {label: translate('Positions'), icon: 'pi pi-briefcase', routerLink: '/hr/positions', command: () => this.layoutService.mobileMenuOpen.set(false)}
        ]
      },
    ]
    this.registry.services().forEach(s => {
      const cl = this.auth.current_locale() ?? "en_us"
      const lang = this.registry.languages().find(l => l.locale === cl)
      const names = s.names || [];
      const _n = names.find(n => n.language_id === lang?.id)
      const n = _n ? _n.name : s.name;
      const icon = ServiceIconMap[s.name] ?? 'pi pi-question-circle';
      menu.push({
        label: n,
        icon,
        routerLink: '/service/' + s.name + '/',
        command: () => this.layoutService.mobileMenuOpen.set(false)
      });
    });
    return menu;
  })
}
